function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M94.612 0H0v149h94.612C137.352 149 172 115.645 172 74.5S137.352 0 94.612 0",
  fill: "#742AA1"
}), React.createElement("path", {
  fill: "#FFBF00",
  d: "M94 149H0l94 74v-74"
}), React.createElement("path", {
  fill: "#F21A76",
  d: "M0 148h94L0 74v74"
}));

var SvgLogoRocketbatch = function SvgLogoRocketbatch(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 172 223"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMTcyIDIyMyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDguMiAoNDczMjcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPnJfbG9nbzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJyX2xvZ28iPgogICAgICAgICAgICA8cGF0aCBkPSJNOTQuNjEyMDMxNiwwIEwwLDAgTDAsMTQ5IEw5NC42MTIwMzE2LDE0OSBDMTM3LjM1MjAxLDE0OSAxNzIsMTE1LjY0NTIyIDE3Miw3NC41MDA0Nzg2IEMxNzIsMzMuMzU0NzgwMSAxMzcuMzUyMDEsMCA5NC42MTIwMzE2LDAiIGlkPSJGaWxsLTEiIGZpbGw9IiM3NDJBQTEiPjwvcGF0aD4KICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJGaWxsLTIiIGZpbGw9IiNGRkJGMDAiIHBvaW50cz0iOTQgMTQ5IDAgMTQ5IDk0IDIyMyA5NCAxNDkiPjwvcG9seWxpbmU+CiAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iRmlsbC0zIiBmaWxsPSIjRjIxQTc2IiBwb2ludHM9IjAgMTQ4IDk0IDE0OCAwIDc0IDAgMTQ4Ij48L3BvbHlsaW5lPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgLogoRocketbatch as ReactComponent };